import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import {onMounted, ref, watchEffect} from "vue";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePickerComponent',
  props: {
  modelValue: {
    type: [String, Array],
    required: false,
    default: moment().toString()
  },
  range: {
    type: Boolean,
    default: false
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props



const currentDate: any = ref('')


onMounted(() => {
  currentDate.value = props.modelValue
})

watchEffect(() => {
  if (currentDate.value) {
    emit('update:modelValue', currentDate.value)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Datepicker), {
    range: __props.range,
    "time-picker": false,
    modelValue: currentDate.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentDate).value = $event))
  }, null, 8, ["range", "modelValue"]))
}
}

})